jQuery(function(){
	var form = jQuery('form.cart');
    var radioContainer = jQuery('#required-app-delivery-options-container');
    var radios = radioContainer.find('.required-class-1327');
    // Set required to false since it loads by default with pickup option.
    radios.prop('required', false);
  
  	form.on('click', '.checkoutMethod', function(event) {      	
      	var selectedButton = jQuery(event.currentTarget);
      	var isPickup = selectedButton.find('.pickupIcon').length;
        var isDelivery = selectedButton.find('.deliveryIcon').length;
      	var radioContainer = jQuery('#required-app-delivery-options-container');
      	var radios = radioContainer.find('.required-class-1327');
		
    	if (isPickup) {
      		console.log('pickup');
          	radios.prop('required', false);
          	radioContainer.hide();
          
      	} else if (isDelivery) {
      		console.log('delivery');
          	radios.prop('required', true);
          	radioContainer.show();
            
      	}		
  })	
})